import Request from '../../../../src/core/gd/data/request'


// This is DEPRECATED - SEE DocumentApi
class ApiWiki {

    constructor() {

    }

    // deprecated - ApiDocumentType.create
    createNoteType(companyId, name, icon, description) {
        return new Request(this, 'POST', 'company/'+companyId+'/note-types', {
            companyId: companyId,
            name: name,
            icon: icon,
            description: description
        });
    }

    getNoteType(companyId, noteTypeId) {
        return new Request(this, 'GET', 'company/'+companyId+'/note-type/'+noteTypeId);
    }


    updateNoteType(companyId, noteTypeId, name, icon, description, template, templateRTF) {
        return new Request(this, 'PUT', 'company/'+companyId+'/note-type/'+noteTypeId,{
            name: name,
            icon: icon,
            description: description,
            template: template,
            templateRTF: templateRTF
        });
    }

    deleteNoteType(companyId, noteTypeId) {
        return new Request(this, 'DELETE', 'company/'+companyId+'/note-type/'+noteTypeId);
    }

    updateSortPositions(companyId, arrIds) {
        return new Request(this, 'PUT', 'company/'+companyId+'/note-types', {
            ids: arrIds
        });
    }

}


module.exports = ApiWiki;